export default "__VITE_ASSET__3e1959d6__"